/*
 * Disaster Tees — client-side filtering for the 64-colorway board.
 *
 * Every tile is already in the DOM, so filtering is a class toggle rather than
 * a fetch: instant, and the full board still renders with JavaScript off.
 * Three independent facets (design, colorway, drop state) combine with AND.
 */
class DTFilter extends HTMLElement {
  connectedCallback() {
    this.state = { design: '', color: '', state: '' };
    this.grid = this.parentElement?.querySelector('[ref="grid"]') ?? null;
    this.count = this.querySelector('[ref="count"]');
    this.empty = this.parentElement?.querySelector('[ref="empty"]') ?? null;
    // Drop state lives on the tile itself, not the wrapper, so read it once
    // here rather than on every keystroke of filtering.
    this.cells = this.grid ? Array.from(this.grid.children) : [];
    for (const cell of this.cells) {
      cell.dataset.state = cell.querySelector('[data-state]')?.dataset.state ?? '';
    }

    this.addEventListener('click', this.#onClick);
    this.#apply();
  }

  #onClick = (event) => {
    const chip = event.target instanceof Element ? event.target.closest('[data-filter]') : null;
    if (!chip) return;

    const facet = chip.dataset.filter;
    if (facet !== 'design' && facet !== 'color' && facet !== 'state') return;

    this.state[facet] = chip.dataset.value ?? '';

    for (const sibling of this.querySelectorAll(`[data-filter="${facet}"]`)) {
      sibling.classList.toggle('is-active', sibling === chip);
    }

    this.#apply();
  };

  #apply() {
    const { design, color, state } = this.state;
    let shown = 0;

    for (const cell of this.cells) {
      const match =
        (!design || cell.dataset.design === design) &&
        (!color || cell.dataset.colorway === color) &&
        (!state || cell.dataset.state === state);
      cell.hidden = !match;
      if (match) shown += 1;
    }

    if (this.count) {
      this.count.textContent = `${shown} of ${this.cells.length} colorways`;
    }
    if (this.empty) this.empty.hidden = shown !== 0;
  }
}

if (!customElements.get('dt-filter')) customElements.define('dt-filter', DTFilter);
